var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomerCreateDialog',{attrs:{"value":true},on:{"created":_vm.onCreated,"click-back":_vm.onClickBack}})}
var staticRenderFns = []

export { render, staticRenderFns }